module.exports = __webpack_public_path__ + "img/bronze.6c902090.png";